module.exports = __webpack_public_path__ + "img/hzm.6ce0b933.png";